module.exports = __webpack_public_path__ + "static/media/kababBlue.5ec20c4c.svg";